module.exports = __webpack_public_path__ + "static/img/living_4.4695109.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/living_4.jpg
// module id = b3O6
// module chunks = 3